import { connect } from "react-redux";
import * as applicationActions from "../actions";
import * as userApplicationActions from "./actions";
import * as usersActions from "../../users/actions";

function mapStateToProps(state) {
  return {
    applications: state.userApplications.applications,
    accountInfos: state.users.accountInfos,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    moveToReview: (id) => {
      dispatch(applicationActions.transfer_to_review(id));
    },

    getApplicationsForAccount: (accountId) => {
      dispatch(applicationActions.get_applications_for_account(accountId));
    },

    changeApplicationListPage: (page) => {
      dispatch(applicationActions.change_application_list_page(page));
    },

    changeApplicationListFilter: (type, key, value) => {
      dispatch(applicationActions.change_application_list_filter(key, value));
    },

    approveApplication: (applicationId, offerId) => {
      dispatch(applicationActions.approve_application(applicationId, offerId));
    },

    rejectApplication: (applicationId) => {
      dispatch(applicationActions.reject_application(applicationId));
    },

    setRiskBasedOffer: (applicationId, accountId, data) => {
      var postData = {
        ApplicationId: applicationId,
        AccountId: accountId,
        ...data,
      };

      dispatch(applicationActions.set_risk_offer(postData));
    },

    setNominalBasedOffer: (applicationId, accountId, data) => {
      var postData = {
        ApplicationId: applicationId,
        AccountId: accountId,
        ...data,
      };

      dispatch(applicationActions.set_nominal_offer(postData));
    },

    getRowAdditionalData: (accountId, identity, bankAccountId, Id) => {
      dispatch(
        userApplicationActions.get_row_additional_data_bisnode(identity, Id),
      );
    },

    swapApplications: () => {
      dispatch(userApplicationActions.swap_data());
    },

    getAccountInfoForId: (accountId) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
    },
  };
}

export const userApplicationsConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
